import Checkbox from './Checkbox.view';

export default Checkbox;
